<div class="card contributor-container">
    <div class="content-left">
        <img src = {{contributor.image}} alt="" class ="proPic">
    </div> 
    <div class="content-right content">
        <div class="content-text">{{contributor.name}}</div>
        <div class="content-text-tiny">({{contributor.designation | translate}})</div>
        <div *ngIf = contributor.features>
            <h6 style="text-decoration:underline;" class = "content-text-mid">{{"contributors.lbl_contributed_features" | translate}}</h6>
            <div *ngFor= "let feature of contributor.features">
                <li class="content-text-tiny">{{feature | translate}}</li>
            </div>
        </div>                        
    </div>
</div>